import { createRoot } from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'
import { FrontendApp } from './App'
import { posthogApiKey, posthogOptions } from './services/analytics'
import '@dev-streetbeat/chat-ui/styles.css'
import './credem-ui.css'
import './styles/global.scss'
import '../agent/styles.css'

const root = document.getElementById('frontend-root')

if (root) {
  const reactRoot = createRoot(root)
  reactRoot.render(
    posthogApiKey ? (
      <PostHogProvider apiKey={posthogApiKey} options={posthogOptions}>
        <FrontendApp />
      </PostHogProvider>
    ) : (
      <FrontendApp />
    ),
  )
}
